import React, { useEffect } from 'react'
import Bundles from '../../Components/Bundles/Bundles'
import './scss/_bundleList.scss'

function BundleList() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <div className='bundle-screen'>
      <div className='bundle-wrapper'>
        <Bundles />
      </div>
    </div>
  )
}

export default BundleList